import React from 'react';
import { Sidebar } from './Sidebar';
type Page = 'dashboard' | 'repayments' | 'applications' | 'glpostings' | 'scheduler' | 'activitylog';
interface LayoutProps {
  children: React.ReactNode;
  currentPage: Page;
  onNavigate: (page: Page) => void;
  onLogout: () => void;
}
export function Layout({
  children,
  currentPage,
  onNavigate,
  onLogout
}: LayoutProps) {
  return <div className="min-h-screen bg-gray-50 flex" data-id="element-388">
      <Sidebar currentPage={currentPage} onNavigate={onNavigate} onLogout={onLogout} data-id="element-389" />
      <main className="flex-1 ml-64 p-8 overflow-y-auto h-screen" data-id="element-390">
        <div className="max-w-7xl mx-auto" data-id="element-391">{children}</div>
      </main>
    </div>;
}